<template>
  <v-dialog v-model="modelNPS" width="700px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card class="pa-3">
      <v-card-text class="pa-0 py-2">
      <v-row>
        <v-col class="v-col-12 px-6 px-sm-0 bg-white text-color-0">
          <v-row v-if="enviado == false">
            <v-col class="v-col-12 v-col-sm-6 offset-sm-3 text-center">
              <svg clip-rule="evenodd" fill-rule="evenodd" height="auto" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 29700 17000" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <linearGradient id="a" gradientUnits="userSpaceOnUse" x1="15821.449862" x2="19857.669862" y1="9975.44379" y2="9975.44379"><stop offset="0" stop-color="#99da00"/><stop offset="1" stop-color="#6dc100"/></linearGradient>
              <linearGradient id="b" gradientUnits="userSpaceOnUse" x1="14862.249862" x2="14862.249862" y1="10983.77379" y2="7091.58379"><stop offset="0" stop-color="#f7a303"/><stop offset="1" stop-color="#f7cc01"/></linearGradient>
              <linearGradient id="c" gradientUnits="userSpaceOnUse" x1="11883.029862" x2="11883.029862" y1="11967.94379" y2="7982.93389"><stop offset="0" stop-color="#ce462d"/><stop offset="1" stop-color="#f33b3c"/></linearGradient>
              <g transform="matrix(2.9577648 0 0 2.9577648 -29106.215 -20883.798)">
                <path d="m13901.14 11253.904c-169.8 194.94-281.28 442.01-307.23 714.04h-3728.9902c39.73-1651.18 880.1202-3103.9202 2147.7202-3985.0102l1039.86 1801.0799z" fill="url(#c)"/><path d="m15821.45 11253.904c169.8 194.94 281.28 442.01 307.23 714.04h3728.99c-39.73-1651.18-880.12-3103.9202-2147.72-3985.0102l-1039.86 1801.0799z" fill="url(#a)"/><path d="m14862.25 7091.5838c908.51 0 1760.22 242.64 2494.37 666.23l-771.92 1337-1090.58 1888.9602c-186.23-106.58-401.92-167.54-631.87-167.54s-445.64 60.96-631.87 167.54l-1090.58-1888.9602-771.92-1337c734.15-423.59 1585.86-666.23 2494.37-666.23z" fill="url(#b)"/><g fill="#970000" transform="translate(-.000138 -676.18621)"><path d="m11725.75 10410.13c427.49 0 774.04 346.55 774.04 774.04s-346.55 774.04-774.04 774.04-774.04-346.55-774.04-774.04 346.55-774.04 774.04-774.04zm0 141.49c349.35 0 632.55 283.2 632.55 632.55s-283.2 632.55-632.55 632.55-632.55-283.2-632.55-632.55 283.2-632.55 632.55-632.55z"/><path d="m11518.85 10928.03c30.85 0 55.85 42.99 55.85 96.02s-25 96.02-55.85 96.02c-30.84 0-55.84-42.99-55.84-96.02s25-96.02 55.84-96.02z"/><path d="m11932.64 10928.03c30.85 0 55.85 42.99 55.85 96.02s-25 96.02-55.85 96.02c-30.84 0-55.84-42.99-55.84-96.02s25-96.02 55.84-96.02z"/><path d="m11434.76 11558.16c-20.38 18.55-51.95 17.06-70.5-3.32s-17.06-51.95 3.32-70.5c117.48-107.04 236.8-161.99 357.98-162.7 121.34-.71 240.98 52.96 358.78 163.09 20.16 18.76 21.3 50.34 2.54 70.5s-50.34 21.3-70.5 2.54c-98.58-92.15-195.38-137.09-290.42-136.53-95.18.56-192.29 46.79-291.2 136.92z" fill-rule="nonzero"/></g><g fill="#167500"><path d="m18036.42 9733.9437c427.49 0 774.04 346.5503 774.04 774.0403s-346.55 774.04-774.04 774.04-774.04-346.55-774.04-774.04 346.55-774.0403 774.04-774.0403zm0 141.49c349.35 0 632.55 283.2003 632.55 632.5503s-283.2 632.55-632.55 632.55-632.55-283.2-632.55-632.55 283.2-632.5503 632.55-632.5503z"/><path d="m17829.52 10251.844c30.85 0 55.85 42.99 55.85 96.02s-25 96.02-55.85 96.02c-30.84 0-55.84-42.99-55.84-96.02s25-96.02 55.84-96.02z"/><path d="m18243.31 10251.844c30.85 0 55.85 42.99 55.85 96.02s-25 96.02-55.85 96.02c-30.84 0-55.84-42.99-55.84-96.02s25-96.02 55.84-96.02z"/><path d="m18327.41 10658.434c20.38-18.55 51.95-17.06 70.5 3.32s17.06 51.95-3.32 70.5c-117.48 107.04-236.8 161.99-357.98 162.7-121.34.71-240.98-52.96-358.78-163.09-20.16-18.76-21.3-50.34-2.54-70.5s50.34-21.3 70.5-2.54c98.58 92.15 195.38 137.09 290.42 136.53 95.18-.56 192.29-46.79 291.2-136.92z" fill-rule="nonzero"/></g><path d="m14862.25 8103.6438c427.49 0 774.04 346.55 774.04 774.04s-346.55 774.0399-774.04 774.0399-774.04-346.5499-774.04-774.0399 346.55-774.04 774.04-774.04zm0 141.49c349.35 0 632.55 283.2 632.55 632.55s-283.2 632.5499-632.55 632.5499-632.55-283.1999-632.55-632.5499 283.2-632.55 632.55-632.55z" fill="#b55100"/><path d="m14655.35 8621.5438c30.85 0 55.85 42.99 55.85 96.02s-25 96.02-55.85 96.02c-30.84 0-55.84-42.99-55.84-96.02s25-96.02 55.84-96.02z" fill="#b55100"/><path d="m15069.14 8621.5438c30.85 0 55.85 42.99 55.85 96.02s-25 96.02-55.85 96.02c-30.84 0-55.84-42.99-55.84-96.02s25-96.02 55.84-96.02z" fill="#b55100"/><path d="m14537.65 9173.5438c-27.61 0-50-22.39-50-50s22.39-50 50-50h649.19c27.61 0 50 22.39 50 50s-22.39 50-50 50z" fill="#b55100" fill-rule="nonzero"/>
              </g>
              <g transform="matrix(2.9577648 0 0 2.9577648 -29106.215 -20883.798)">
                <path :class="position" d="m15362.19 12569.434-.46.52-.02-.04c-142.75 142.65-345.17 223.6-561.95 204.71-389.41-33.93-677.59-377.13-643.65-766.54 21.44-245.99 166.31-451.54 368.27-561.06l-.03-.04.23-.06c375.32-203.37 1941.2-563.04 2458.19-712.99-512.31 580.25-1085.34 1299.88-1620.58 1835.5zm-514.81-760.05c165.58 14.43 288.12 160.36 273.69 325.94-14.44 165.6-160.36 288.14-325.95 273.71-165.6-14.43-288.13-160.36-273.7-325.96 14.43-165.59 160.36-288.12 325.96-273.69z" fill="#323a45"/>
              </g>
              </svg>
            </v-col>
          </v-row>
          <v-row v-if="enviado == false">
            <v-col class="v-col-12 v-col-sm-8 offset-sm-2 text-center mb-2">
              <p class="text-small">
                <b v-if="order_id != null && is_physical_nps == 0">Como foi a experiência de compra online?</b>
                <b v-else-if="order_id != null && is_physical_nps == 1">Como foi a experiência de compra?</b>
                <b v-else>Você está satisfeito com nossos serviços?</b><br>
                Avalie nosso trabalho de 0 à 10.
              </p>
              <div class="w-100 mb-6 mt-4">
                <v-btn v-for="b in buttons" :key="b.value" :value="b.value" :color="b.color" class="mx-1 mx-lg-2 mt-2 btn-nps font-weight-bold" :variant="myToggle != b.value ? 'tonal': 'flat'" :rounded="'circle'" @click="myToggle = b.value">{{ b.value }}</v-btn>
              </div>
              <p class="text-small">
                Deixe sua opinião.<br>Escreva o que você mais gostou e o que podemos melhorar.
              </p>
            </v-col>
            <v-col class="v-col-12 v-col-sm-8 offset-sm-2 mb-2">
              <v-textarea variant="outlined" :hide-details="true" class="mt-2" v-model="obs"></v-textarea>
              <v-btn variant="flat" block size="large" class="bg-color-2 text-color-white mt-3" :loading="loading" @click="enviaNota();">Enviar</v-btn>
            </v-col>
          </v-row>
          <v-row v-if="enviado == true">
            <v-col class="v-col-12 v-col-sm-8 offset-sm-2 my-2 text-color-0 py-8">
              <h2>Obrigado! 🤗</h2>
              <h4>Sua pesquisa foi respondida com sucesso.</h4>
              <hr class="fine-line my-5">
              <p>
              Sua opinião é muito importante para nós, para nos auxiliar a melhorar cada vez mais o nosso trabalho, principalmente em relação aos nossos produtos e ao atendimento oferecido.
              </p>
              <p>
              Em todas as suas compras lembre-se sempre de se identificar com o número do seu CPF no caixa, assim a gente entende o que você mais gosta e traz ofertas e serviços personalizados.
              </p>
              <p>Equipe <b>{{ storeConfig.store_name }}</b></p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'DialogNPS',
  data() {
    return {
      modelNPS: false,
      position: '',
      pointerInterval: null,
      obs: "",
      myToggle: null,
      buttons: [
        { value: 0, color: 'error' },
        { value: 1, color: 'error' },
        { value: 2, color: 'error' },
        { value: 3, color: 'error' },
        { value: 4, color: 'error' },
        { value: 5, color: 'error' },
        { value: 6, color: 'error' },
        { value: 7, color: 'warning' },
        { value: 8, color: 'warning' },
        { value: 9, color: 'success' },
        { value: 10, color: 'success' }
      ],
      enviado: false,
      loading: false
    }
  },
  computed: {
    ...mapState('main', {
      storeConfig: 'storeConfig'
    }),
  },
  props: {
    order_id: {
      type: Number,
      default: null
    },
    is_physical_nps: {
      type: Number,
      default: 0
    },
    model: {
      type: Boolean,
      default: false,
      required: true
    },
    fechar: {
      type: Function,
      default: null,
      required: true
    }
  },
  watch: {
    model() {
      this.modelNPS = this.model;
      this.enviado = false;
      this.myToggle = null;
      if(this.model == true){
        this.pointerInterval = setInterval(this.pointer, 2000);
      }
    },
    'myToggle': function(n){
      clearInterval(this.pointerInterval);
      if(n <= 6){
          this.position = "rotate-left pointer-transition-fast";
      } else if(n >= 7 && n <= 8){
          this.position = "rotate-center pointer-transition-fast";
      } else if(n >= 9){
          this.position = "rotate-right pointer-transition-fast";
      } else {
          this.position = "";
      }
    }
  },
  methods: {
    ...mapActions('order', {
      setNps: 'setNps'
    }),
    enviaNota(){
      if(this.myToggle == null){
        this.emitter.emit('dialogMessage', { title: "Ops!", message: "Por favor, selecione uma nota." });
      } else if(this.myToggle <= 6 && this.obs == ''){
        this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Tem certeza de que não quer nos informar o motivo da sua avaliação?", response: this.sendNota });
      } else {
        this.sendNota(true); 
      }
    },
    sendNota: function(r){
      if(r){
        this.loading = true;
        let request = {
          note: this.myToggle,
          obs: this.obs
        }
        if(this.order_id != null){
          request.order_id = this.order_id;
          request.is_physical_nps = this.is_physical_nps;
        }
        this.setNps(request).then(function(response){
          if(response.cod == 200){
            this.enviado = true;
          } else {
            this.emitter.emit('dialogMessage', { title: "Ops!", message: response.msg });
          }
          this.loading = false;
        }.bind(this));
      }
    },
    pointer(){
      if(this.position == "rotate-full-right"){
        this.position = "rotate-full-left";
      } else {
        this.position = "rotate-full-right";
      }
    },
  },
  unmounted(){
    clearInterval(this.pointerInterval);
  }
}
</script>